/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Status_Queued_PagesInputs */



/**
* | output |
* | --- |
* | "Queued — monthly pages used" |
*
* @param {Spaces_Status_Queued_PagesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_status_queued_pages = /** @type {((inputs?: Spaces_Status_Queued_PagesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Status_Queued_PagesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wartet — monatliche Seiten aufgebraucht")
	return /** @type {LocalizedString} */ ("Queued — monthly pages used")
});